var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { CreateShareableLink, ShareLinkState, ToggleOptionsPanel, UpdateShareableLink } from '../share-link.state';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
var LinkOptionsComponent = /** @class */ (function () {
    function LinkOptionsComponent(store) {
        this.store = store;
        this.form = new FormGroup({
            password: new FormControl(),
            expiresAt: new FormGroup({
                date: new FormControl(),
                time: new FormControl(),
            }),
            allowEdit: new FormControl(false),
            allowDownload: new FormControl(true)
        });
        this.passwordVisible = new FormControl(false);
        this.expirationVisible = new FormControl(false);
    }
    LinkOptionsComponent.prototype.ngOnInit = function () {
        this.bindToLinkChange();
    };
    LinkOptionsComponent.prototype.toggleOptionsPanel = function () {
        this.store.dispatch(new ToggleOptionsPanel());
    };
    LinkOptionsComponent.prototype.saveChanges = function () {
        if (this.store.selectSnapshot(ShareLinkState.link)) {
            this.store.dispatch(new UpdateShareableLink(this.getPayload()));
        }
        else {
            this.store.dispatch(new CreateShareableLink(this.getPayload()));
        }
    };
    LinkOptionsComponent.prototype.getPayload = function () {
        var payload = {
            allowEdit: this.form.get('allowEdit').value,
            allowDownload: this.form.get('allowDownload').value,
        };
        if (this.expirationVisible.value) {
            payload.expiresAt = this.form.get('expiresAt.date').value;
            if (this.form.get('expiresAt.time').value) {
                payload.expiresAt += ' ' + this.form.get('expiresAt.time').value;
            }
        }
        // not sending "password" with request will remove it from link
        if (this.passwordVisible.value) {
            payload.password = this.form.get('password').value;
        }
        return payload;
    };
    LinkOptionsComponent.prototype.bindToLinkChange = function () {
        var _this = this;
        this.link$.pipe(filter(function (link) { return !!link; }))
            .subscribe(function (link) {
            _this.hydrateExpirationForm(link);
            // show or hide password form field
            _this.passwordVisible.setValue(!!link.password);
            _this.expirationVisible.setValue(!!link.expires_at);
            _this.form.patchValue({
                allowEdit: link.allow_edit,
                allowDownload: link.allow_download
            });
        });
    };
    LinkOptionsComponent.prototype.hydrateExpirationForm = function (link) {
        if (!link || !link.expires_at)
            return;
        var parts = link.expires_at.split(' ');
        this.form.get('expiresAt').setValue({
            date: parts[0],
            time: parts[1]
        });
    };
    LinkOptionsComponent.prototype.getMinDate = function () {
        return new Date().toJSON().split('T')[0];
    };
    __decorate([
        Select(ShareLinkState.link),
        __metadata("design:type", Observable)
    ], LinkOptionsComponent.prototype, "link$", void 0);
    __decorate([
        Select(ShareLinkState.loading),
        __metadata("design:type", Observable)
    ], LinkOptionsComponent.prototype, "loading$", void 0);
    __decorate([
        Select(ShareLinkState.backendErrors),
        __metadata("design:type", Observable)
    ], LinkOptionsComponent.prototype, "backendErrors$", void 0);
    return LinkOptionsComponent;
}());
export { LinkOptionsComponent };
